import { IAction } from '~/src/store';

import { ETicketPayment } from './index';

export type TSetInProcess = IAction<ETicketPayment.SET_IN_PROCESS, boolean>

const setInProcess = (status: boolean): TSetInProcess => ({
    type: ETicketPayment.SET_IN_PROCESS,
    payload: status,
});

export default setInProcess;
